import {
  fontSizeVars,
  fontWeightVars,
  lineHeightVars,
} from '@tundr/ds-foundations';
import { colClass, rowClass, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const radioGroupLabelClass = style({
  fontSize: fontSizeVars.body.body1,
  fontWeight: fontWeightVars.bold,
  lineHeight: lineHeightVars.body.body1,
  marginBottom: themeVars.space.x5,
});

export const radioGroupOptionLabelClass = style({
  fontSize: fontSizeVars.body.body1,
  fontWeight: fontWeightVars.bold,
  lineHeight: lineHeightVars.body.body1,
  marginBottom: themeVars.space.x2,
  cursor: 'pointer',
});

export const horizontalRadioGroupClass = style([
  rowClass,
  {
    gap: themeVars.space.x10,
    flexWrap: 'wrap',
  },
]);

export const verticalRadioGroupClass = style([
  colClass,
  {
    gap: themeVars.space.x10,
    flexWrap: 'wrap',
  },
]);
